(function () {
  if (customElements.get('cart-countdown-timer')) return;

  class CartCountdownTimer extends HTMLElement {
    connectedCallback() {
      this.duration = parseInt(this.dataset.duration, 10) || 300;
      this.remaining = this.duration;
      this.render();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      this.remaining -= 1;
      if (this.remaining <= 0) {
        // Boucle infinie : redémarre automatiquement le compte à rebours.
        this.remaining = this.duration;
      }
      this.render();
    }

    render() {
      var m = Math.floor(this.remaining / 60).toString().padStart(2, '0');
      var s = (this.remaining % 60).toString().padStart(2, '0');
      var timeEl = this.querySelector('.cart-countdown-timer__time');
      if (timeEl) timeEl.textContent = m + ':' + s;
    }
  }

  customElements.define('cart-countdown-timer', CartCountdownTimer);
})();
